/**
 * The table itself — every column the global Events tab draws, and what a
 * single venue's "Coming up" section now draws too, `showVenue` off since
 * the venue is already the page's own heading there.
 */
import { expandedFields, priceText, typeLabel, whenText, type FeedEvent } from './eventFields'

export function EventsTable({ events, showVenue = true }: { events: FeedEvent[]; showVenue?: boolean }) {
  return (
    <div className="events-tablewrap">
      <table className="events-table">
        <thead>
          <tr>
            <th>When</th>
            {showVenue && <th>Venue</th>}
            <th>Title</th>
            <th>Type</th>
            <th>Details</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {events.map(e => {
            const price = priceText(e)
            const details = expandedFields(e)
            return (
              <tr key={e.id}>
                <td className="nowrap">{whenText(e)}</td>
                {showVenue && <td>{e.venue ?? e.building ?? <span className="dim">—</span>}</td>}
                <td>
                  {e.url
                    ? <a href={e.url} target="_blank" rel="noopener noreferrer">{e.title}</a>
                    : e.title}
                </td>
                <td><span className="tag">{typeLabel(e.type)}</span></td>
                <td>
                  {details.length
                    ? (
                      <dl className="eventfields">
                        {details.map((d, i) => (
                          <div className="eventfields__row" key={i}>
                            <dt>{d.label}</dt>
                            <dd>{d.value}</dd>
                          </div>
                        ))}
                      </dl>
                    )
                    : <span className="dim">—</span>}
                </td>
                <td className="nowrap">{price ?? <span className="dim">—</span>}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
